import styled from '@emotion/styled';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';
import { COLORS_TEXT } from '@zola/zola-ui/src/styles/emotion/colors';

export const HeroWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 60px;

  ${MEDIA_QUERY.DESKTOP} {
    flex-direction: row;
    gap: ${SPACING.LG};
    justify-content: space-between;
  }
`;

export const HeroContent = styled.div`
  h1 {
    margin-bottom: ${SPACING.MD};
    font-weight: 500;
    font-size: ${FONT.FONT_SIZE_LARGER};
    line-height: 44px;
  }

  p {
    margin-bottom: ${SPACING.MD};
    font-size: ${FONT.FONT_SIZE_REGULAR};
    line-height: 32px;
    font-family: ${FONT.FONT_FAMILY_SANS_SERIF};
  }

  ${MEDIA_QUERY.MOBILE} {
    p {
      font-size: ${FONT.FONT_SIZE_SMALL};
    }
  }
`;

export const HeroImage = styled.img`
  border-radius: 4px;
  margin-bottom: ${SPACING.MD};

  ${MEDIA_QUERY.DESKTOP} {
    margin-bottom: initial;
    max-height: 350px;
  }
`;

export const Subhead = styled.h2`
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  font-size: ${FONT.FONT_SIZE_LARGE};
  line-height: ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_LARGE)};
  color: ${COLORS_TEXT.PRIMARY};
  margin-bottom: ${SPACING.LG};

  ${MEDIA_QUERY.MOBILE} {
    font-size: ${FONT.FONT_SIZE_REGULAR};
    line-height: ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_REGULAR)};
  }
`;

export const StateContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${SPACING.LG};
  grid-auto-rows: auto;
  margin-bottom: ${SPACING.XL};

  ${MEDIA_QUERY.MOBILE} {
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: ${SPACING.LG};
    gap: 32px;
  }
`;

export const StateLink = styled(LinkV2)`
  font-size: ${FONT.FONT_SIZE_REGULAR};
  line-height: 20px;
  text-transform: initial;
  font-family: ${FONT.FONT_FAMILY_SANS_SERIF};

  ${MEDIA_QUERY.MOBILE} {
    font-size: ${FONT.FONT_SIZE_SMALL};
    line-height: 16px;
  }
`;

export const CrossSellContainer = styled.div`
  padding-bottom: ${SPACING.LG};
`;
